import React from 'react';

export const PauseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="10.737" height="12.526" viewBox="0 0 10.737 12.526">
    <path id="ic_pause_24px" d="M6 17.526h3.579V5H6zM13.158 5v12.526h3.579V5z" fill="#1592e6"
          transform="translate(-6 -5)"/>
  </svg>
);
